<template>
  <div class="content_box" v-loading="loading">
    <div class="img_box">
      <div class="img_box_in">
        <el-row :gutter="36">
          <el-col :span="12" v-for="(item,index) in questionList" :key="index">
            <el-card shadow="always">
              <div class="img_box_in_card" @click="messageDetails(item)">
                <p>
                  <span v-if="index<9">0</span>{{index+1}}
                </p>
                <div>
                  <p class="img_box_in_card_title" :title="item.question">{{item.question}}</p>
                  <!-- <p class="img_box_in_card_content" :title="item.answer" v-html="item.answer"></p> -->
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
      <div class="pageList" v-if="isShowPagination">
        <pagination :msg="page" @refreshList="onRefresList" @handleSizeChange='handleSizeChange'></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getQuestion} from '@/api/commonProblems'
import pagination from "./Pagination.vue";
export default {
  components: { pagination },
  props:{
    isShowPagination:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      loading: false,
      questionList: [],
      page: {
        size: 10,
        current: 1,
        total: 1
      }
    }
  },
  created(){
    this.setQuestion();
  },
  methods:{
    messageDetails(item) {
      this.$router.push({ name: "newsDetails", query: { data: JSON.stringify(item),types:1 } });
    },
    onRefresList(val) {
      this.page.current = val;
      this.setQuestion();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.setQuestion();
    },
    async setQuestion() {
      this.loading = true;
      let res=await getQuestion(this.page)
      if (res.code == 200 && res.result) {
        if(!this.isShowPagination){
          // res.result.rows.forEach((item,index) => {
          //   if(index<=7){
          //     this.questionList.push(item)
          //   }
          // });
          this.questionList = res.result.records.filter((item,index)=>{
            if(index<8){
              return item
            }
          })
        } else {
          this.questionList = res.result.records;
        }
        this.page.total = res.result.total;
      }
      this.loading = false;
    }
  }
}
</script>

<style lang="less" scoped>
.content_box{
  .img_box {
    width: 1153px;
    margin: 0 auto;
    // height: 780px;
    box-sizing: border-box;
    padding: 30px;
    padding-top: 0;
    .img_box_in {
      // height: 400px;
      min-height: 400px;
      width: 100%;
      // border-bottom: 1px dashed #E5E5E5;
      .el-card__body{
        padding: 0;
        height: 171px;
        border-radius: 8px;
      }

      .el-card{
        margin-bottom: 47px;
      }
      .el-card:hover{
        transform: translateY(-20px);
      }

      .img_box_in_card{
        display: flex;
        // padding: 42px 28px;
        cursor: pointer;
        >p{
          width: 36px;
          height: 36px;
          background: #2F89EB;
          box-shadow: 0px 8px 15px 0px rgba(47, 137, 235, 0.35);
          border-radius: 50%;
          line-height: 36px;
          text-align: center;
          font-size: 18px;
          color: #fff;
          padding-right: 2px;
          box-sizing: border-box;
          margin-right: 24px;
          font-style:oblique;
        }

        div{
          width: 420px;
          line-height: 36px;
        }

        &_title{
          font-weight: bold;
          font-size: 16px;
          color: #333;
          // margin-bottom: 14px;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &_title:hover{
          color: #2F89EB;
        }

        &_content{
          font-size: 14px;
          color: #666666;
          overflow : hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          height: 60px;
          -webkit-box-orient: vertical;
        }
      }
    }
    .footer {
      margin-top: 88px;
      color: #999999;
      font-size: 14px;
    }
    .pageList {
      position: relative;
      margin-top: 30px;
      text-align: right;
      span {
        position: absolute;
        left: 0;
        top: 10px;
        color: #999999;
        font-size: 14px;
      }
      .el-pagination {
        // display:inline-block;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/commonProblems.vue